import React, { memo, useState } from 'react';
import GeneralSelectFilter, {
  FilterItemType,
} from '@gp/components/GeneralSelectFilter';
import { useMemoizedFn } from 'ahooks';
import './index.scss';
import TriggerFoldBtn from '@/pages/globalpedia/components/TriggerFoldBtn';

interface FilterPropsType {
  loading: boolean;
  options: FilterItemType[];
  onChange:
    | ((studio: string[], project: string[], handleFilterName: string) => void)
    | null;
  triggerFoldExpand: boolean;
  getState: (() => void) | null;
}

const DEFAULT_PROPS: FilterPropsType = {
  loading: true,
  options: [],
  onChange: null,
  triggerFoldExpand: false,
  getState: null,
};

function Filter(props: FilterPropsType) {
  const { loading, options, onChange, triggerFoldExpand, getState } = props;

  const handleSelectFilterChange = useMemoizedFn(
    (payload, handleFilterName) => {
      onChange?.(
        payload?.studio || [],
        payload?.project || [],
        handleFilterName,
      );
    },
  );

  return (
    <div className="dbg-studio-monthly-report-in-development-card-filter">
      <GeneralSelectFilter
        options={options}
        onChange={handleSelectFilterChange}
      />
      <TriggerFoldBtn
        foldBubble="Expand"
        contentText={'Show more Milestone Times'}
        state={triggerFoldExpand}
        onClick={getState}
      />
    </div>
  );
}

Filter.defaultProps = DEFAULT_PROPS;

export default memo(Filter);
